<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <div>
                        <img src="@/assets/images/charging-cancel.png" alt="" />
                    </div>
                    <span v-html="message">

                    </span>
                </div>
            </div>
            
            <div class="button-wrap">
                <button class="button-bg-yellow border-round" @click="confirmEvent()">확인</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'alertPopup',
    props:['message'],
    components: {},
    data() {
        return  {
        }
    },
    methods: {
        confirmEvent() {
            this.$emit('confirmPopupClickConfirm', 'confirm');
        },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/cancelChargingPopup.scss';
    @import '@/assets/styles/common/bottomButton.scss';
</style>